import React from "react";

import { Sliders as SlidersIcon } from "@phosphor-icons/react";
import { useRootElement } from "../context";

import * as styles from "./styles";

export const AllFiltersButton = () => {
  const { setIsFiltersDialogOpen } = useRootElement();

  return (
    <button
      className={styles.button}
      onClick={() => setIsFiltersDialogOpen(true)}
    >
      <SlidersIcon className={styles.icon} />
    </button>
  );
};
